import React, {
    useCallback, useState, useMemo
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { WizardPageTemplateWithTitle } from 'gw-portals-wizard-components-ui';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { UWIssuesUtil } from 'premier-capability-hooks';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { PolicyChangeDetailsComponent } from 'gw-capability-policyjob-react'
import ConfirmationQuoteDetailsPage from '../Confirmation/ConfirmationPage';
import presentationMetadata from './QuotePage.metadata.json5';
import messages from './QuotePage.messages';
import '../../PolicyChangeCommon.messages';

const confirmation = {
    path: '/confirmation',
    component: ConfirmationQuoteDetailsPage,
    stepProps: {
        template: WizardPageTemplateWithTitle
    }
};

function QuotePage(props) {
    const {
        wizardData: policyChangeVM, updateWizardData, changeNextSteps, underwritingIssues, currentStep
    } = props;
    const { pageKey } = currentStep;
    const metadata = presentationMetadata[pageKey];
    const [isPolicyBinding, setIsPolicyBinding] = useState(false);
    const isQuoteBlocked = UWIssuesUtil.isQuoteBlockedForPolicyChange(underwritingIssues);
    const findBlockingPoint = UWIssuesUtil.findBlockingPoint(underwritingIssues);

    const {
        onValidate
    } = useValidation('PremierPCQuotePage');

    const policyDetailsData = useMemo(() => 
         ({
            effectiveDate: _.get(policyChangeVM.value, 'baseData.effectiveDate'),
            policyPeriod: {
                startDate: _.get(policyChangeVM.value, 'baseData.periodStartDate'),
                endDate: _.get(policyChangeVM.value, 'baseData.periodEndDate')
            },
            previousPremium: _.get(policyChangeVM.value, 'previousTotalCost'),
            changeInCost: _.get(policyChangeVM.value, 'changeInCost'),
            newPremium: _.get(policyChangeVM.value, 'totalCost'),
            taxes: _.get(policyChangeVM.value, 'taxesAndSurcharges'),
            fee: _.get(policyChangeVM.value, 'policyFee') +
                _.get(policyChangeVM.value, 'inspectionFee') + _.get(policyChangeVM.value, 'extensionFee'),
            newPremiumBeforeTaxes: _.get(policyChangeVM.value, 'totalPremium'),
            address: _.get(policyChangeVM.value, 'baseData.policyAddress.displayName'),
            policyNumber: _.get(policyChangeVM.value, 'policyNumber')
        })
        // doesn't required to return submissionVM
        // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

    const handleNext = useCallback(async () => {
        setIsPolicyBinding(true);

        const steps = [];

        if (_.isEmpty(steps.find((step) => step.path === confirmation.path))) {
            const newSteps = [confirmation];

            changeNextSteps(newSteps);
        }

        // const jobID = _.get(policyChangeVM.value, 'jobID');
        // const { jobType } = policyChangeVM.value.baseData;
        // const billingContactIdExt = _.get(policyChangeVM.value, 'baseData.billingContactId_Ext');

        // const handleBindResponse = await handleBindProcess('PersonalAuto', 'PersonalAutoQuotePage', jobID, policyChangeVM.value, `redistribute`, jobType, billingContactIdExt);

        // if(!_.isUndefined(handleBindResponse?.jumpLocation)){
        //     window.location = handleBindResponse?.jumpLocation;

        //     return false;
        // }

        // const {errorsAndWarnings} = handleBindResponse.bindResponse.policyChange;

        // if(!_.isUndefined(errorsAndWarnings)){
        //     _.set(policyChangeVM, 'value', handleBindResponse.bindResponse.policyChange);
        //     _.set(policyChangeVM, 'value.jobID', jobID);
        // } else {
        //     _.set(policyChangeVM, 'value', handleBindResponse.bindResponse);
        // }

        updateWizardData(policyChangeVM);

        return policyChangeVM;
    }, [changeNextSteps, policyChangeVM, updateWizardData]);

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top'
            }
        },
        policyChangeDetails: {
            policyDetails: policyDetailsData,
        },
        policyChangeContainer: {
            visible: _.get(policyChangeVM.value, 'transactionCost.amount') > 0
        },
        underWritingIssues: {
            underwritingIssues,
            blockQuote: findBlockingPoint,
            filterUWIssuesInCustomOffering: false,
            quoteID: _.get(policyChangeVM.value, 'jobID'),
            jobType: _.get(policyChangeVM.value, 'baseData.jobType'),
            accountNumber: _.get(policyChangeVM.value, 'baseData.accountNumber')
        },
        lobDetails: {
            productCode: _.get(policyChangeVM.value, 'baseData.productCode')
        },
        selectPayer: {
            visible: false // ! isRV
        }
    };

    const resolvers = {
        resolveComponentMap: {
            PolicyChangeDetailsComponent
        }
    };

    return (
        <WizardPage
            disableNext={isPolicyBinding || isQuoteBlocked}
            onNext={handleNext}
            nextLabel={messages.finish}
        >
            <ViewModelForm
                model={policyChangeVM}
                uiProps={metadata.content}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

QuotePage.propTypes = wizardProps;
export default QuotePage;